import { SidebarTrigger } from '#app/components/ui/sidebar'

export function MobileHeader() {
	return (
		<header className="bg-background text-foreground sticky top-0 flex w-screen min-w-0 flex-col justify-start pt-5 pb-6 pl-32 hover:z-10">
			<h2 className="text-3xl leading-none font-semibold tracking-tight text-nowrap sm:text-3xl">
				Clearwater Farms
			</h2>
			<h3 className="text-lg leading-none tracking-tight text-nowrap sm:text-xl">
				Unit 1
			</h3>
			<div className="fixed top-4 left-4 z-50">
				<SidebarTrigger />
			</div>
		</header>
	)
}
